// extracted by mini-css-extract-plugin
export var rendezVousPart6Text = "rendez-vous-part-6-module--rendez-vous-part-6-text--d9665";
export var rendezVousRecapContainer = "rendez-vous-part-6-module--rendez-vous-recap-container--8c04e";
export var rendezVousTitle = "rendez-vous-part-6-module--rendez-vous-title--45c63";